import { Edit, ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  IconButton,
  Typography
} from '@mui/material'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import ConditionalCheckboxList from 'components/CustomCheckboxList/CustomCheckboxList'
import { NotFound } from 'components/NotFound/NotFound'
import { useContractStore } from 'context/ContractStore'
import React, { lazy, startTransition, Suspense, useState } from 'react'

const UserRevertModal = lazy(() => import('components/RoleModals/UserRevertModal/UserRevertModal'))

export const CustomAccordion = ({
  open = true,
  title,
  data = [],
  checkboxData = [],
  column = '3',
  isEdit = null,
  readonly = null
}) => {
  const [expanded, setExpanded] = useState(open)

  const {
    contractStore: { loanApplicationData },
    contractStoreFunc: { setManagerWorking }
  } = useContractStore()
  const [openEdit, setOpenEdit] = useState(null)

  const openEditModal = (e, isEdit) => {
    e.stopPropagation()
    setManagerWorking(true)
    startTransition(() => {
      setOpenEdit(isEdit)
    })
  }

  const closeEditModal = () => {
    setManagerWorking(false)
    setOpenEdit(null)
  }

  const handleChange = () => {
    setExpanded(prevExpanded => !prevExpanded)
  }

  return (
    <>
      <Suspense
        fallback={
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        }
      >
        {openEdit && <UserRevertModal openModal={openEdit} closeModal={closeEditModal} />}
      </Suspense>

      <Accordion
        expanded={expanded}
        onChange={readonly ? undefined : handleChange}
        sx={{
          border: `1px solid ${GRAY_COLORS[200]}`,
          padding: expanded ? '20px' : '0 20px 0 20px'
        }}
      >
        <AccordionSummary expandIcon={!readonly && <ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography variant="subtitle1">{title}</Typography>
          {isEdit && !readonly && loanApplicationData?.status?.code === 'userRevert' && (
            <IconButton
              sx={{
                padding: 1,
                margin: 0,
                marginLeft: 'auto',
                '&:hover': {
                  backgroundColor: INFO_COLORS[400]
                },
                backgroundColor: GRAY_COLORS[200]
              }}
              onClick={e => openEditModal(e, isEdit)}
            >
              <Edit />
            </IconButton>
          )}
        </AccordionSummary>

        <AccordionDetails sx={{ paddingBottom: checkboxData.length > 0 ? '32px' : '0' }}>
          {data.length > 0 ? (
            <Box display="grid" gridTemplateColumns={`repeat(${column}, 1fr)`} gap={4}>
              {data.map((item, index) => (
                <FieldInfoNG key={index} label={item.label} isVertical>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, wordBreak: 'break-word', color: GRAY_COLORS[900] }}>
                    {item.value}
                  </Typography>
                </FieldInfoNG>
              ))}
            </Box>
          ) : (
            <NotFound />
          )}
        </AccordionDetails>
        {!readonly && checkboxData.length > 0 && <ConditionalCheckboxList data={checkboxData} />}
      </Accordion>
    </>
  )
}
